import { axios, API } from "@/imports-files/common/common";
import { SendRequest } from "@/imports-files/pages/admins/logout";

export class AddNewStageService extends SendRequest
{
  async addStage(params, job_id) {
    try {
      const result = await axios.post(API.client.kanban.ADD_NEW_STAGE.replace('$job_id', job_id),
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async addStageInfo(job_id) {
    try {
        const result = await axios.get(API.client.kanban.NEW_STAGE_INFO.replace('$job_id', job_id),
        {
          params: {},
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
        return result;
    } catch (error) {
      return error;
    }
  }
}